<template>
  <div :class="['tag', tagColors, size]">
    <IconWrapper
      v-if="showImg && icon" :name="icon" class="icon" :icon-height="16"
      alt="icon" @click="$emit('icon-action')"
    />
    <span>{{ label }}</span>
    <IconWrapper
      v-if="showClose" :name="'closeIcon'" class="close" :icon-height="16"
      alt="close" @click="$emit('close-action')"
    />
  </div>
</template>

<script setup lang="ts">
import IconWrapper from '@/components/common/icons/IconWrapper.vue'
import { TagSizes, TagColors } from './utils'

withDefaults(
  defineProps<{
    label?: string
    showClose?: boolean
    showImg?: boolean
    icon?: string
    tagColors?: TagColors
    size?: TagSizes
  }>(),
  {
    showClose: true,
    showImg: true,
    icon: '',
    tagColors: TagColors.Black,
    size: TagSizes.Small
  }
)

defineEmits(['close-action', 'icon-action'])
</script>

<style lang="scss" scoped>
.tag {
  display: flex;
  align-items: center;
  border-radius: 4px;
  width: fit-content;
  white-space: nowrap;
  gap: 4px;

  &.big {
    font-size: 0.875rem;
    padding: 4px 8px;
  }
  &.small {
    font-size: 0.75rem;
    padding: 3px 8px;
  }

  &.black {
    background: $videoOrientationBackgroundColor;
    color: $white;
  }

  &.grey {
    background: $categoriesLabelBackground;
    color: $titleBlack;

    .close {
      filter: invert(1);
    }

    img {
      filter: invert(1);
    }
  }

  &.white {
    border: 1px solid $videoOrientationBorderColor;
    background: transparent;
    color: $titleBlack;

    .close {
      filter: invert(1);
    }

    img {
      filter: invert(1);
    }
  }
}

.close {
  cursor: pointer;
}
</style>
